<template>
    <LoadingSpinner v-if="loading" />
    <DxToast v-model:visible="isToastVisible"
             v-model:message="toastMessage"
             :displayTime="4000"
             maxWidth="80%">
    </DxToast>
    <DxPopup v-model:visible="aiFilter.showPopup"
             :hide-on-outside-click="false"
             height="auto"
             width="auto"
             :drag-enabled="false"
             :max-height="800"
             :full-screen="showAsFullscreen"
             title="Please Select"
             :show-close-button="true">
        <div class="crmPopupContent">
            <div class="crmPopupBody" v-if="aiFilter.groupData.length > 0">
                <DxTreeView id="treeview"
                            v-model:value="aiFilter.value"
                            ref="treeViewRef"
                            height="550px"
                            :items="aiFilter.groupData"
                            show-check-boxes-mode="normal"
                            :search-enabled="true"
                            search-mode="contains"
                            keyExpr="LitId"
                            parentIdExpr="LitParentId"
                            itemsExpr="Childs"
                            displayExpr="LitName"
                            selectedExpr="Selected"
                            expandedExpr="expand"
                            selection-mode="multiple"
                            x@itemRendered="treeItemRender"
                            x@itemSelectionChanged="(e) => treeClick(e, data)"
                            x@selection-changed="(e) => treeViewSelectionChanged(e,data)"
                            :select-nodes-recursive="true"
                            :select-by-click="true">
                    <template #item="item">
                        {{ item.data.LitName  }}
                    </template>
                </DxTreeView>
            </div>
            <div class="crmPopupFooter">
                <DxButton text="Select"
                          type="default"
                          @click="CloseAiFilter(data)"></DxButton>
            </div>
        </div>
    </DxPopup>

    <DxPopup v-model:visible="popupApply.visible"
             :title="popupApply.title"
             width="60%"
             :drag-enabled="false"
             :max-height="600"
             height="auto"
             :max-width="700"
             :show-close-button="true"
             content-template="applying">

        <template #applying>
            <div v-if="profile.LookingForAMentor && accessList._300751">
                <div>
                    {{popupApply.descriptionOffer}}
                </div>
                <div class="puChangeStateButtons">
                    <div class="puChangeStateButton">
                        <DxButton text="Yes"
                                  type="success"
                                  @click="ApplyMentorToMemberOnServer()"></DxButton>
                    </div>
                    <div class="puChangeStateButton">
                        <DxButton text="No"
                                  type="default"
                                  @click="popupApply.visible = false" />
                    </div>
                </div>
            </div>
            <div v-if="profile.OfferingMentoring && accessList._300741">
                <div>
                    {{popupApply.descriptionApply}}
                </div>
                <div class="puChangeStateButtons">
                    <div class="puChangeStateButton">
                        <DxButton text="Yes"
                                  type="success"
                                  @click="ApplyMemberToMentoOnServer()"></DxButton>
                    </div>
                    <div class="puChangeStateButton">
                        <DxButton text="No"
                                  type="default"
                                  @click="popupApply.visible = false" />
                    </div>
                </div>
            </div>

        </template>
    </DxPopup>

    <div class="page-content">
        <div class="content">
            <h1 class="pqHeadFirst">Community</h1>
            <h2 class="pqHeadSec">AI Grid gathers a large community of young talents and experts specialized in AI. You can here check the profiles of the community members. <br /> </h2>
            <span class="pqHeadThird">You can search for members by profile type and by AI research field. Get in touch with them!</span>
            <div class="mfgButtonsTop">
                <div class="mfgButton mfgBackButton">
                    <DxButton text="Back"
                              styling-mode="text"
                              type="default"
                              icon="fa-regular fa-circle-arrow-left"
                              @click="backToOverview($event)" />
                </div>
            </div>
            <div class="puFilter">
                <div class="puAiFilter">
                    <div class="puLabel">
                        Members by profile type:
                        <!--{{selectedTopicType}}-->
                    </div>
                    <div class="puValue">
                        <DxSelectBox :data-source="communityList"
                                     :show-clear-button="true"
                                     display-expr="TtyName"
                                     value-expr="TtyId"
                                     width="100%"
                                     v-model:value="selectedTopicType">
                        </DxSelectBox>
                    </div>
                </div>
                <div class="puAiFilter">
                    <div class="puLabel">
                        Search by Name:
                    </div>
                    <div class="puValue">
                        <DxTextBox placeholder="Type a Name" :value="searchText" v-model:text="searchText"></DxTextBox>
                    </div>
                </div>
                <div class="puAiFilter">
                    <div class="puLabel">
                        Search by  AI research field:
                    </div>
                    <div class="puValue">
                        <DxButton text="Choose search field" @click="ShowAiFilter"></DxButton>
                    </div>
                </div>
                <div class="puAiFilter">
                    <DxButton v-if="aiFilter.selectedItems.length" text="reset filter" type="default" styling-mode="text" icon="fal fa-circle-xmark" @click="ResetAiFilter"></DxButton>
                </div>
            </div>
            <div class="puAiTagFilter">
                <div v-for="item in aiFilter.selectedItems" :key="item.LitId" class="puAiTag">
                    {{ item.LitName }}
                </div>
            </div>
            <div class="tltProfilesContainer">
                <div class="tltCardContainer tltMyProfile tltCommunity">
                    <div v-for="profile in profileListFiltered" :key="profile.TopicId" class="tltCardBox">
                        <div class="tltProfileBox">
                            <div class="tltStatus">
                                <div v-if="profile.IsAmbassador" class="tltStatusButtonAmbassador">Ambassador</div>
                                <div v-else-if="profile.TtyId==22 && !profile.IsAmbassador" class="tltStatusButton">Member</div>
                                <div v-else-if="profile.TtyId==24 && !profile.IsAmbassador" class="tltStatusButton tltStatusMentorButton">Mentor</div>
                            </div>
                            <div class="tltName" @click="ViewApp(profile.TopicId)">
                                {{ profile.UsrFirstName }}<br />{{ profile.UsrLastName }}
                            </div>
                            <div :class="{tltCrtStatus:true, hideField:!profile.CurrentStatus && !profile.Institute && !profile.CurrentStatus2 && !profile.Institute2}">
                                <div  v-if="profile.TtyId==22" :class="{hideField:!profile.CurrentStatus , tltFiledValues:true}">
                                    <div><i class="fa-regular fa-graduation-cap"></i> {{profile.CurrentStatus}}</div>
                                </div>
                                <div v-if="profile.TtyId==22" :class="{hideField:!profile.Institute , tltFiledValues:true ,lookingInst:true, institute:true}">
                                    <div class="tltFiledValues"><i class="fa-regular fa-building-columns"></i> {{profile.Institute}}</div>
                                </div>     
                                <div v-if="profile.TtyId==24" :class="{hideField:!profile.CurrentStatus2 , tltFiledValues:true}">
                                    <div><i class="fa-regular fa-graduation-cap"></i> {{profile.CurrentStatus2}}</div>
                                </div>
                                <div v-if="profile.TtyId==24" :class="{hideField:!profile.Institute2 , tltFiledValues:true  ,offeringInst:true, institute:true}">
                                    <div class="tltFiledValues"><i class="fa-regular fa-building-columns"></i> {{profile.Institute2}}</div>
                                </div>
                            </div>
                            <div class="tltSocialMediaLinks">
                                <div :class="{tltLinkButton:true, hasSocialmedia:profile.UsrAccountLinkedIn > ''}">
                                    <a v-if="profile.UsrAccountLinkedIn" :href="getLink(profile.UsrAccountLinkedIn)" target="_blank"><i class="fa-brands fa-linkedin"></i></a>
                                    <i v-else class="fa-brands fa-linkedin"></i>
                                </div>
                                <div :class="{tltLinkButton:true, hasSocialmedia:profile.ContactViaSlack > ''}">
                                    <a v-if="profile.ContactViaSlack && !profile.UsrSlack" href="https://aigrid.slack.com/" target="_blank"> <i class="fa-brands fa-slack"></i></a>
                                    <a v-else-if="profile.ContactViaSlack && profile.UsrSlack" :href="getLinkSlack(profile.UsrSlack)" target="_blank"> <i class="fa-brands fa-slack"></i></a>
                                    <i v-else class="fa-brands fa-slack"></i>
                                </div>    
                                <div :class="{tltLinkButton:true, hasSocialmedia:profile.UsrGoogle > '' ,google:true}">
                                    <a v-if="profile.UsrGoogle" :href="getLink(profile.UsrGoogle)" target="_blank"><img :src="GoogleScholar"/></a>
                                    <img v-else :src="GoogleScholar" />
                                </div>

                                <div :class="{tltLinkButton:true, hasSocialmedia:profile.UsrEMail != ''}">
                                    <a v-if="profile.UsrEMail" :href="'mailto:' + profile.UsrEMail" target="_blank"><i class="fas fa-envelope"></i></a>
                                    <i v-else class="fas fa-envelope"></i>
                                </div>
                                <div class="tltLinkButton lookingOffering" v-if="profile.TtyId==24">
                                    <div :class="{tltOfferMentoring:profile.OfferingMentoring ,offering:!profile.OfferingMentoring}">
                                        <i class="fal fa-bell"></i>  Offering Mentoring
                                    </div>
                                </div>
                                <div class="tltLinkButton lookingOffering" v-if="profile.TtyId==22">
                                    <div :class="{tltLookMentore:profile.LookingForAMentor ,offering:!profile.LookingForAMentor}">
                                        <i class="fal fa-binoculars"></i>  Looking for a Mentor
                                    </div>
                                </div>
                            </div>

                            <div class="tltPhoto">
                                <div>
                                    <img v-lazy="profile.ProfilePhoto" alt="ProfilePhoto" class="tltProfilePhoto" />
                                </div>
                            </div>

                            <div class="tltDevider"></div>

                            <div class="tltFields">
                                <div class="tltFieldLabel">Fields of Research in AI</div>
                                <span class="tltFiledValues" v-for="(field, i) in profile.FieldOfResearch" v-bind:key="field.LitId">
                                    <span v-if="i > 0">, </span><span :title="field.LitName">{{ field.LitShortName }}</span>
                                </span>
                            </div>

                            <div class="tltMfgs">
                                <div class="tltMfgLabel">Micro Focus Group</div>
                                <div v-for="mfg in profile.MfgTitleList" :key="mfg.TopicId" class="tltLinkItem">
                                    <div class="tltMfgLinkTemplate" @click="OpenMorePopUp(mfg.TopicId)">
                                        {{ mfg.Title }}
                                    </div>
                                </div><div v-if="!profile.MfgTitleList || profile.MfgTitleList.length == 0" class="tltLinkEmptyItem">
                                    No Micro Focus Group Selected
                                </div>

                            </div>

                            <div class="tltAction">
                                <div @click="ApplyMentorToMember(profile)" v-if="profile.LookingForAMentor && accessList._300751 && !profile.MentorIsLinkedToMe" class="tltActionButton tltActionApply">
                                    <div class="tltActionIcon">
                                        <i class="fa-light fa-plus"></i>
                                    </div>
                                    <div class="tltActionLabel">
                                        Connect
                                    </div>
                                </div>
                                <div @click="ApplyMemberToMentor(profile)"
                                     v-if="profile.OfferingMentoring && accessList._300741 && !profile.MentorIsLinkedToMe" class="tltActionButton tltActionApply">
                                    <div class="tltActionIcon">
                                        <i class="fa-light fa-plus"></i>
                                    </div>
                                    <div class="tltActionLabel">
                                        Connect
                                    </div>

                                </div>
                                <div class="tltStatusWorkflowButton" v-else-if="profile.MentorIsLinkedToMe">
                                    {{profile.LinkedMentorStatusShortName}}
                                </div>
                                <div @click="EditApp" v-if="writeAccess" class="tltActionButton">
                                    <div class="tltActionIcon">
                                        <i class="fa-regular fa-gear"></i>
                                    </div>
                                    <div class="tltActionLabel">
                                        Edit
                                    </div>
                                </div>
                                <div @click="ViewApp(profile.TopicId)" v-else class="tltActionButton">
                                    <div class="tltActionIcon">
                                        <i class="far fas fa-eye"></i>
                                    </div>
                                    <div class="tltActionLabel">
                                        View
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="img-bg">
            <div class="bg-image-sq">
                <img class="bg-image" v-bind:src="bgSq" />
            </div>
        </div>
    </div>

    <DxPopup v-model:visible="popup.visible"
             :title="popup.title"
             height="auto"
             :max-width="1200"
             :drag-enabled="false"
             :show-close-button="true"
             content-template="interested">

        <template #interested>
            <DxScrollView direction="vertical"
                          show-scrollbar="always"
                          scroll-by-content="true"
                          scroll-by-thumb="true">
                <div class="puMessage">
                    <div class="mfgInfo">
                        <div class="description">
                            <div class="mfgPopUpTlt">
                                About this Micro Focus Group
                            </div>
                            <div class="mfgPopUpText">
                                {{popup.description}}
                            </div>
                        </div>
                        <div class="mfg-img">
                            <img class="mfg-img" :src="popup.imgUrl" v-if="popup.imgUrl" />
                        </div>
                    </div>

                    <!--<div>
                        <span class="mfgPopUpTlt">
                            MFG created on:
                        </span>

                    </div>-->
                    <div class="mfg-mentors mfg-membership" v-if="popup.ambassadors && popup.ambassadors.length>0">
                        <div class="tltStatus">
                            <span class="tltStatusButton tltStatusButtonAmbassador">
                                Ambassadors
                            </span>
                        </div>
                        <span class="prof">
                            <span class="mfg-img" v-for="topic in  this.popup.ambassadors" :key="topic.TopicId">
                                <img id="link3" @mouseenter="ToggleDefaultAmbassasor(topic)" @click="OpenProfile(topic)"
                                     @mouseleave="ToggleDefaultAmbassasor(topic)" class="mfg-img-prof" v-if="topic.ProfilePhoto" :src="topic.ProfilePhoto">
                                <i class="mfg-img-prof fal fa-user" id="link3" @mouseenter="ToggleDefaultAmbassasor(topic)"
                                   @mouseleave="ToggleDefaultAmbassasor(topic)" @click="OpenProfile(topic)" v-else />
                            </span>
                        </span>
                    </div>
                    <div class="all_profiles">

                        <div class="membersMentors">

                            <div class="mfg-membership" v-if="popup.members && popup.members.length>0">
                                <div class="tltStatus">
                                    <span class="tltStatusButton">
                                        Members
                                    </span>
                                </div>
                                <span class="mfg-prof">
                                    <span class="mfg-img" v-for="topic in  this.popup.members" :key="topic.TopicId">
                                        <img id="link1" @mouseenter="ToggleDefaultMember(topic)"
                                             @mouseleave="ToggleDefaultMember(topic)"
                                             @click="OpenProfile(topic)"
                                             class="mfg-img-prof" v-if="topic.ProfilePhoto"
                                             :src="topic.ProfilePhoto">
                                        <i class="mfg-img-prof fal fa-user" id="link1" @mouseenter="ToggleDefaultMember(topic)"
                                           @mouseleave="ToggleDefaultMember(topic)"
                                           @click="OpenProfile(topic)" v-if="!topic.ProfilePhoto" />
                                    </span>
                                </span>
                            </div>
                            <div class="mfg-mentors mfg-membership" v-if="popup.mentors && popup.mentors.length>0">
                                <div class="tltStatus">
                                    <span class="tltStatusButton tltStatusMentorButton">
                                        Mentors
                                    </span>
                                </div>
                                <span class="prof">
                                    <span class="mfg-img" v-for="topic in  this.popup.mentors" :key="topic.TopicId">
                                        <img id="link2" @mouseenter="ToggleDefaultMentor(topic)"
                                             @click="OpenProfile(topic)"
                                             @mouseleave="ToggleDefaultMentor(topic)" class="mfg-img-prof" v-if="topic.ProfilePhoto" :src="topic.ProfilePhoto">
                                        <i class="mfg-img-prof fal fa-user" id="link2" @mouseenter="ToggleDefaultMentor(topic)"
                                           @mouseleave="ToggleDefaultMentor(topic)" @click="OpenProfile(topic)" v-else />
                                    </span>
                                </span>
                            </div>

                        </div>
                    </div>
                    <DxPopover :width="auto"
                               heigth="100"
                               max-width="500"
                               :shading="false"
                               :visible="memberPopoverVisible"
                               :hideOnOutsideClick="false"
                               target="#link1"
                               position="top"
                               content-template="popoverContent1">
                        <template #popoverContent1>
                            <div class="popoverContent1">
                                <div class="pop_over_first mfg-membership">
                                    <div class="tltStatus tltDevider">
                                        <div class="data-caption">
                                            <div class="tltStatusButton">
                                                Member
                                            </div>
                                            <p>
                                                {{ topicDetail.UsrFirstName}}
                                                <br />
                                                {{ topicDetail.UsrLastName}}
                                            </p>
                                        </div>

                                        <img class="mfg-img-prof" v-if="topicDetail.ProfilePhoto" :src="topicDetail.ProfilePhoto">
                                        <i class="mfg-img-prof far fa-user" v-else />


                                    </div>


                                </div>
                                <div class="popOver-field">
                                    <span>Current status </span>  <br /> <span class="data-caption">{{ topicDetail.TdgText004}}</span>
                                </div>
                                <div class="popOver-field">
                                    <span>Fields of Research in AI</span> <br />
                                    <span class="data-caption" v-for="(tag,index) in topicDetail.AiTagsGrouped" :key="tag.LitParentId">
                                        <span v-if="index>0">, {{tag.LitShortName }}</span>
                                        <span v-else>{{tag.LitShortName }}</span>
                                    </span>
                                </div>
                            </div>
                        </template>

                    </DxPopover>

                    <DxPopover :width="auto"
                               heigth="100"
                               max-width="500"
                               :visible="mentorPopoverVisible"
                               target="#link2"
                               position="top"
                               content-template="popoverContent2">
                        <template #popoverContent2>
                            <div class="popoverContent2">
                                <div class="pop_over_first mfg-membership">
                                    <div class="tltStatus">
                                        <div class="data-caption ">
                                            <div class="tltStatusButton tltStatusButtonAmbassador" v-if="topicDetail.IsAmbassador">Ambassador</div>
                                            <div class="tltStatusButton tltStatusMentorButton" v-else>Mentor</div>
                                            <div class="tltMentorName">
                                                {{ topicDetail.UsrFirstName}}
                                                {{ topicDetail.UsrLastName}}
                                            </div>
                                        </div>
                                        <img class="mfg-img-prof" v-if="topicDetail.ProfilePhoto" :src="topicDetail.ProfilePhoto">
                                        <i class="mfg-img-prof far fa-user" v-else />
                                    </div>

                                </div>
                            </div>
                        </template>

                    </DxPopover>
                    <DxPopover :width="auto"
                               heigth="100"
                               max-width="500"
                               :visible="ambassadorPopoverVisible"
                               target="#link3"
                               position="top"
                               content-template="popoverContent3">
                        <template #popoverContent3>
                            <div class="popoverContent3">
                                <div class="pop_over_first mfg-membership">
                                    <div class="tltStatus">
                                        <div class="data-caption ">
                                            <div class="tltStatusButton tltStatusButtonAmbassador">Ambassador</div>
                                            <div class="tltMentorName">
                                                {{ topicDetail.UsrFirstName}}
                                                {{ topicDetail.UsrLastName}}
                                            </div>
                                        </div>
                                        <img class="mfg-img-prof" v-if="topicDetail.ProfilePhoto" :src="topicDetail.ProfilePhoto">
                                        <i class="mfg-img-prof far fa-user" v-else />
                                    </div>

                                </div>
                            </div>
                        </template>

                    </DxPopover>

                    <div v-if="popup.events && popup.events.length > 0">
                        <span class="mfgPopUpTlt">
                            Events:
                        </span>
                    </div>

                </div>
                <!--<div class="mfgChangeStateButtons">
                    <div class="mfgChangeStateButton">
                        <DxButton text="Close"
                                  @click="PopupCancel"
                                  icon="fal fa-circle-xmark"
                                  type="default"></DxButton>
                    </div>
                    <div class="mfgChangeStateButton">
                        <DxButton text="Apply"
                                  @click="ApplyForMfg"
                                  :disabled="popup.isLinked"
                                  icon="fal fa-circle-xmark"
                                  type="success">
                        </DxButton>
                    </div>
                </div>-->
            </DxScrollView>
        </template>

    </DxPopup>

</template>
<script>
    import moment from "moment";
    import { DxButton } from 'devextreme-vue/button';
    import DxSelectBox from 'devextreme-vue/select-box'
    import DxTextBox from 'devextreme-vue/text-box'
    //import axios from "axios";
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import LoadingSpinner from "@/views/widgets/LoadingSpinner"
    import { DxPopover } from 'devextreme-vue/popover';
    import { DxPopup } from 'devextreme-vue/popup';
    import { DxToast } from 'devextreme-vue/toast';
    import { DxTreeView } from 'devextreme-vue/tree-view';
    import $ from 'jquery';
    //const baseUri = "WebApi.asmx/api/application";
    export default {

        name: 'ProfileStatus',
        components: {
            DxScrollView,
            DxButton,
            DxPopover,
            DxPopup,
            LoadingSpinner,
            DxSelectBox,
            DxTreeView,
            DxToast,
            DxTextBox
        },
        data() {
            return {
                GoogleScholar : "~/Images/Google-scholar.svg",
                searchText: '',
                aiFilter: {
                    showPopup: false,
                    value: null,
                    groupData: [],
                    allItems: [],
                    selectedKeys: [],
                    selectedItems: []
                },
                showContact: false,
                isToastVisible: false,
                toastMessage: "",
                aiListItems: [],
                ambassador: [],
                topicDetail: {},
                ambassadorPopoverVisible: false,
                memberPopoverVisible: false,
                mentorPopoverVisible: false,
                communityList: [
                    {
                        TtyName: "Mentors",
                        TtyId: 24
                    },
                    {
                        TtyName: "Members",
                        TtyId: 22
                    },
                    {
                        TtyName: "Ambassador",
                        TtyId: 23
                    },
                ],
                selectedTopicType: null,
                popup: {
                    visible: false,
                    title: " ",
                    loading: true,
                    topicId: 0,
                    //data: {},
                    createdOn: "",
                    mentors: [],
                    members: [],
                    events: [],
                    description: " ",
                    imgUrl: " "
                },
                popupApply: {
                    visible: false,
                    title: "",
                    loading: true,
                    descriptionApply: "You'd like to send a request for mentoring support. Is that right ?",
                    descriptionOffer: "You'd like to send a offer for mentoring support. Is that right ? "
                },
                profile: null,
                loading: false,
                moment: moment,
                topicLinkList: [],
                profileList: [],
                myProfiles: [],
                mentorRequests: [],
                showLinkStatusInfo: true,
                writeAccess: false,
                readAccess: false,
                submitted: false,
                post: null,
                fullfill: 0,
                missingFields: [],
                missed: 0,
                TopicId: 0,
                StatusId: 0,
                StgId: 0,
                //iconRew: "~/Images/221219_AI-Grid_Icon_Application.svg",
                //iconFeed: "~/Images/221219_AI-Grid_Icon_Invitation.svg",
                iconSent: "~/Images/230112_AI-Grid_Icon_Sent.svg",
                bgSq: "",
                logoBmbf: "~/Images/Logo_BMBF_en.svg",
            }
        },
        computed: {
            showAsFullscreen() {
                return window.innerWidth < 600
            },
            accessList() {
                return this.$store.state.accessStore.accessList
            },
            mfgList() {
                var result = this.$store.state.topicLinkStore.mfgList.filter(m => m.StgId >= 10 && m.StgId < 20);
                return result
            },
            iconRew() {

                return "~/Images/230112_AI-Grid_Icon_Review.svg"
            },
            iconFeed() {

                return "~/Images/230112_AI-Grid_Icon_Feedback.svg"
            },
            mode() {
                let uri = window.location.search.substring(1);
                let params = new URLSearchParams(uri);
                return params.get("mode");
            },
            args() {
                let uri = window.location.search.substring(1);
                let params = new URLSearchParams(uri);
                return params.get("args");
            },

            profileListFiltered() {
                if (!this.profileList)
                    return []

                var res = [];
                var list = this.profileList.filter(m => {
                    if (this.selectedTopicType != 23)
                        res = (this.selectedTopicType == null || (m.TtyId == this.selectedTopicType && !m.IsAmbassador))
                            && (this.aiFilter.selectedKeys.length == 0 ||
                                m.FieldOfResearch.filter(i => {
                                    var result = this.aiFilter.selectedKeys.filter(a => i.Children.map(c => c.LitId).contains(a)).length > 0;
                                    return result;
                                }
                                ).length > 0
                            )
                    else
                        res = (m.IsAmbassador)
                            && (this.aiFilter.selectedKeys.length == 0 ||
                                m.FieldOfResearch.filter(i => {
                                    var result = this.aiFilter.selectedKeys.filter(a => i.Children.map(c => c.LitId).contains(a)).length > 0;
                                    return result;
                                }
                                ).length > 0
                            )
                    return res;
                });
                return (this.searchText && this.searchText.length > 0) ? list.filter(m => (m.UsrFirstName.toLowerCase() + ' ' + m.UsrLastName.toLowerCase()).includes(this.searchText.toLowerCase())) : list;
            }
        },
        props: {
            filterStgId: {
                type: [Number],
                required: false,
                default: 0
            }
        },
        created: function () {
            this.loading = true;
            Promise.all([
                this.GetMfgList(),
                this.LoadAiGridCommunityProfiles(),
                this.LoadMyAiGridProfiles(),
                this.LoadListItems(),
                this.LoadAccessList(),

            ]).then(() => {
                this.loading = false
                if (localStorage.getItem("selectBoxFilter") != null && localStorage.getItem("selectBoxFilter") != 'NaN' && localStorage.getItem("selectBoxFilter") != 'null')
                    this.selectedTopicType = Number(localStorage.getItem("selectBoxFilter"))

                if (localStorage.getItem("selectTextFilter") != "null" && localStorage.getItem("selectTextFilter") != '') {
                    this.searchText = localStorage.getItem("selectTextFilter")
                }

            });

        },
        watch: {
            selectedTopicType: function (newVal, oldVal) {
                if (newVal != oldVal)
                    localStorage.setItem("selectBoxFilter", newVal);
            },
            searchText: function (newVal, oldVal) {
                if (newVal != oldVal)
                    localStorage.setItem("selectTextFilter", newVal);
            }

        },
        methods: {
            LoadAccessList() {
                return this.$store.dispatch("getAccessList", { tokenList: ["300741", "300751"] });
            },
            GetMfgList() {
                return this.$store.dispatch("getMfgList", {})
            },
            LoadListItems() {
                return this.$store.dispatch("getListListItem", { LisId: 1005, Type: 0 }).then(res => {
                    if (res.success) {
                        var list = res.listItemList;
                        this.aiListItems = list;

                        var result = list.filter(m => {
                            return m.LitParentId == null;
                        }).map(m => {
                            var ele1 = {
                                LitId: m.LitId,
                                LitParentId: null,
                                LitParent: null,
                                LitName: m.LitName,
                                Childs: list.filter(c => c.LitParentId == m.LitId)
                                    .map(i => {
                                        var ele2 = {
                                            LitId: i.LitId,
                                            LitParentId: i.LitParentId,
                                            LitParent: m,
                                            LitName: i.LitName,
                                            LitNameWithParent: i.LitName,
                                            expand: false,
                                            Selected: false, //selectedKeys.indexOf(i.Value) >= 0,
                                        }
                                        this.aiFilter.allItems.push(ele2)
                                        return ele2
                                    }),
                                Selected: false
                            };
                            return ele1;
                        });
                        this.aiFilter.groupData = result;
                    }
                })
            },
            LoadAiGridCommunityProfiles() {
                return this.$store.dispatch("getAiGridCommunityProfiles").then((res) => {
                    this.profileList = res.data.profile;
                    this.profileListFiltered = res.data.profile;

                    if (this.mode == "ApplyForMentor") {
                        this.selectedTopicType = 24;
                    }
                    else if (this.mode == "ApplyForMember") {
                        this.selectedTopicType = 22;
                    }
                    else {
                        this.selectedTopicType = null;
                    }
                });
            },
            LoadMyAiGridProfiles() {
                return this.$store.dispatch("getMyAiGridProfiles", { ttyId: null }).then((res) => {
                    this.myProfiles = res.data.profiles;
                    this.mentorRequests = this.myProfiles && this.myProfiles.length > 0 ? this.myProfiles[0].MentorList : [];
                    if (!this.profileList)
                        return [];
                })
            },
            ApplyMemberToMentor(profile) {
                this.popupApply.visible = true;
                this.popupApply.title = "Apply for Mentoring Support";
                this.profile = profile;

            },
            backToOverview() {
                window.location.href = window.location.pathname + "?action=back&args=" + this.args;
            },
            ApplyMemberToMentoOnServer() {
                this.$store.dispatch("addMemberToMentor", { args: this.args, topicId: this.profile.TopicId, ttyId: 22 })
                    .then(res => {
                        this.loading = false
                        if (res.data.success) {
                            Promise.all([
                                this.LoadMyAiGridProfiles(),
                                this.LoadAiGridCommunityProfiles()
                            ]).then(() => {
                                this.isToastVisible = true;
                                this.toastMessage = "Your request for mentorship has been successfully forwarded to the Mentor.";
                            });
                        }
                    })
                this.popupApply.visible = false;
            },
            getLink(link) {
                if (!link || link == "" || link.substring(4).toLowerCase() == "http") {
                    return link;
                }
                return "http://" + link;
            },
            getLinkSlack(link) {
                if (!link || link == "" || link.substring(4).toLowerCase() == "http") {
                    return link;
                }
                return " ";
            },
            contactMe(profile) {
                var elem = document.getElementById(profile.TopicId);

                if (elem.className == "shrinkedContacts") {
                    elem.className = "expandContacts";
                    elem.parentElement.classList.add("expand");
                }

                else {
                    elem.className = "shrinkedContacts";
                    elem.parentElement.classList.remove("expand");
                }

            },
            ApplyMentorToMember(profile) {
                this.popupApply.visible = true;
                this.popupApply.title = "Offer mentoring";
                this.profile = profile;
            },
            ApplyMentorToMemberOnServer() {
                this.loading = true
                this.$store.dispatch("addMentorToMember", { args: this.args, topicId: this.profile.TopicId, ttyId: 22 })
                    .then(res => {
                        this.loading = false
                        if (res.data.success) {
                            Promise.all([
                                this.LoadMyAiGridProfiles(),
                                this.LoadAiGridCommunityProfiles()
                            ]).then(() => {
                                this.isToastVisible = true;
                                this.toastMessage = "You have successfully offered the mentorship";
                            });
                        }
                    })
                this.popupApply.visible = false;
            },
            ShowAiFilter() {
                this.aiFilter.showPopup = true;
            },
            OpenProfile(topic) {
                $("form").attr("action", window.location.pathname + "?action=view&topicId=" + topic.TopicID).submit()
            },
            ToggleDefaultMember(topic) {
                this.topicDetail = topic;
                this.memberPopoverVisible = !this.memberPopoverVisible;
            },
            ToggleDefaultMentor(topic) {
                this.topicDetail = topic;
                this.mentorPopoverVisible = !this.mentorPopoverVisible;
            },
            ToggleDefaultAmbassasor(topic) {
                this.topicDetail = topic;
                this.ambassadorPopoverVisible = !this.ambassadorPopoverVisible;
            },
            ViewApp(topicId) {
                this.loading = true;
                $("form").attr("action", window.location.pathname + "?action=view&topicId=" + topicId).submit()
            },
            ApplyForMfg() {
                $("form").attr("action", window.location.pathname + "?action=applyForMfg&topicId=" + this.popup.topicId).submit()
            },
            PopupCancel() {
                this.popup.visible = false;
            },
            CloseAiFilter() {
                this.aiFilter.selectedKeys = this.aiFilter.allItems.filter(m => m.Selected).map(m => m.LitId);
                this.aiFilter.selectedItems = this.aiFilter.allItems.filter(m => m.Selected).map(m => {
                    return {
                        LitId: m.LitId,
                        LitName: m.LitName
                    }
                });
                this.aiFilter.showPopup = false;
            },
            ResetAiFilter() {
                this.aiFilter.selectedKeys = [];
                this.aiFilter.selectedItems = [];
                this.$refs.treeViewRef.instance.unselectAll()
            },
            OpenMorePopUp(topicId) {
                this.loading = true
                this.$store.dispatch("getMfgData", topicId).then((m) => {
                    this.popup.topicId = topicId;
                    this.loading = false
                    this.popup.members = m.data.Members.filter(m => m.IsLinkMember == false && m.StgId == 15);
                    this.popup.isLinked = m.data.Members.filter(m => m.IsLinkMember == true).length > 0;
                    this.popup.mentors = m.data.Mentors.filter(m => !m.IsAmbassador && m.StgId == 15);
                    this.popup.ambassadors = m.data.Mentors.filter(m => m.IsAmbassador && m.StgId == 15);
                    this.popup.events = m.data.Events;
                    this.popup.visible = true;
                    this.popup.data = m.data;
                    this.popup.title = m.data.Title;
                    this.popup.description = m.data.Description;
                    this.popup.imgUrl = m.data.ImgUrl;
                })

            },
        }
    }
</script>
<style scoped>
    .tltMfgLinkTemplate {
        cursor: pointer;
    }
    .google img {
        block-size: 19px;
        vertical-align: top;
    }
    .tltDevider {
        border-bottom: solid 1px silver;
    }

    .popoverContent1 {
        display: grid;
        row-gap: 5px;
    }

    .all_profiles {
        display: grid;
        grid-auto-flow: column;
        padding-top: 15px;
        grid-template-rows: 1fr;
    }

    .membersMentors {
        display: grid;
        grid-column-gap: 30px;
        grid-template-columns: 2fr 1fr;
    }

    div.tltContactIcon i {
        align-self: center;
    }

    .shrinkedContacts {
        max-width: 0;
        min-width: 0;
        transition: min-width .6s;
        display: flex;
        height: 20px;
        overflow: hidden;
        flex-direction: row;
        column-gap: 10px;
        padding: 5px 0px 5px 0px;
    }

    .tltProfileBox .tltContact .tltContactMeButton {
        justify-content: center;
    }

    .puMessage {
        display: grid;
        font-size: 15px;
    }

    div.tltContactIcon {
        display: flex;
        flex-direction: row;
        background-color: white;
    }

    .expandContacts {
        max-width: 50px;
        transition: max-width .6s;
        height: 20px;
        display: flex;
        overflow: hidden;
        flex-direction: row;
        align-items: center;
        column-gap: 10px;
        padding: 5px 10px 5px 5px;
    }

    .tltContactIcon.expand {
        background-color: #ebebeb;
        column-gap: 10px;
        border-radius: 14px;
        padding: 0px 5px;
    }


    .crmPopupFooter {
        padding-top: 30px;
    }

    .mfgChangeStateButtons {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        margin-top: 10px;
    }

    .tltName {
        cursor: pointer;
    }


    .pqHeadFirst {
        text-align: left;
    }

    h2.pqHeadSec {
        max-width: 900px;
    }

    .fields {
        padding-top: 25px;
    }

        .fields ul {
            font-weight: normal;
            padding: 0px;
        }

    #app li {
        padding-bottom: 15px;
        margin-left: 0px;
        list-style-type: none;
    }

    img.icon {
        opacity: 0.3;
    }

    .progress span {
        color: var(--bg-color1);
        font-weight: bold;
    }

    img.iconfeedResult {
        display: none;
    }

    img.iconSent.icon, img.iconRew.icon, img.iconRew.icon {
        opacity: 1;
    }

    img.iconFeed.icon, span.iconFeed, span.accepted, span.declined {
        display: none;
    }



    .divider {
        display: inline-block;
        border-bottom: #999999 1px solid;
        width: 70px;
        color: #999999;
        vertical-align: middle;
    }

    .line {
        align-items: center;
        margin-bottom: 40px;
    }



    .register {
        margin-top: 10px;
        font-size: 15px;
        font-weight: bold;
        color: white;
        text-align: center;
    }

    .icon-app {
        margin-bottom: -5px;
        max-width: 600px;
        display: grid;
        grid-template-columns: 20% 20% 20% 20% 20%;
        column-gap: 5px;
        padding: 30px 45px 20px 0px;
    }

    div.icon-app > div {
        display: grid;
        font-size: 15px;
        color: #a3a3a3;
        font-weight: bold;
        grid-row-gap: 12px;
        text-align: center;
        justify-items: center;
    }

    .tltLinkEmptyItem {
        padding-top: 0px;
        color: #c5c5c5;
    }

    .puValue .dx-button {
        height: 46px;
        width: 200px;
    }

    .puFilter {
        display: grid;
        gap: 18px;
        grid-template-columns: 1fr 1fr 1fr auto;
        max-width: 726px;
    }

    .puTypeFilter {
        max-width: fit-content;
    }

    .puAiFilter {
        display: flex;
        flex-direction: column;
        row-gap: 14px;
    }

    .puAiTagFilter {
        display: flex;
        flex-direction: row;
        z-index: 1;
        flex-wrap: wrap;
        gap: 5px;
        margin-top: 10px;
    }

    .puAiFilter .puValue {
    }

    .puAiTag {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
        padding: 5px;
        border-radius: 5px;
        z-index: 100;
        background: white;
    }

    .lgi-btns {
        padding-top: 30px;
        display: flex;
        flex-direction: row;
        column-gap: 20px;
        row-gap: 10px;
    }

    .missing-fields {
        padding-top: 30px;
        display: grid;
        grid-row-gap: 15px;
    }

        .missing-fields span {
            color: #465a64;
        }

        .missing-fields div {
            color: #465a64;
            font-size: 15px;
            font-weight: bold;
        }

    span.grey-text {
        font-size: 15px;
        margin: 0px 20px 0px 20px;
        color: #a3a3a3;
        font-weight: bold;
    }

    img.icon {
        /*padding-right: 45px;*/
    }


    h4, h3 {
        color: #465a64;
        font-size: 17px;
        font-weight: lighter;
    }

    h4 {
        margin: 0px 0px 10px 0px;
        max-width: 90%;
    }

    h3.head-forth {
        color: #00a4e0;
        margin: 35px 0px 15px 0px;
        font-size: 17px;
        font-weight: bold;
    }

    h3.head-third {
        margin: 35px 0px 10px 0px;
        font-weight: bold;
    }

    .prfCaption {
        font-weight: bold;
        padding-bottom: 10px;
    }

    .prfLinkListBox {
        display: grid;
        grid-template-columns: auto auto auto auto 1fr;
        gap: 10px;
        font-size: 12px;
        padding-bottom: 20px;
    }

    .prfIcon {
        text-align: center;
        padding-right: 2px;
    }

    .prfTopicId {
        font-weight: 600;
    }

    .mfgPopUpTlt {
        font-size: 15px;
        font-weight: 700;
        margin-bottom: 5px;
    }

    img.mfg-img {
        max-height: 370px;
        -o-object-fit: cover;
        object-fit: cover;
    }

    .prfLinkTemplate {
        cursor: pointer;
    }

    .prfTopicId {
        font-weight: 600;
    }

    .prfStatus {
        color: var(--m02-color-1);
    }

    .prfStatusChangedby {
        align-self: self-end;
    }

    .prfLinkType.prfCaption {
        margin-top: 30px;
    }

    .prfLinkTemplate {
        cursor: pointer;
    }

        .prfLinkTemplate span {
            color: var(--m01-color-1);
        }

    .prfLinkItem {
        display: contents;
    }


    .page-content {
        width: 100%;
        display: grid;
        grid-template-columns: auto auto;
        margin: 10px 0px 10px 0px;
    }

    .progress {
        display: flex;
        column-gap: 10px;
        padding-top: 15px;
    }

    .progress-bar {
        border-width: 0px;
        border-radius: 10px;
        height: 20px;
        width: 500px;
    }

    .filled-bar {
        background-color: #ec9b4d;
        width: 0%;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        height: 20px;
        position: absolute;
    }

    .fullfill {
        position: relative;
    }

    div.missing-fields div.fullfill div.fullfill-percent {
        position: absolute;
        font-size: 12px;
        height: 20px;
        margin-top: 3px;
        color: #465a64;
        margin-left: 50%;
        font-weight: normal;
    }

    .filled-bar-grey {
        background-color: #ebebeb;
        width: 100%;
        float: right;
        color: white;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        height: 20px;
    }

    /* Extra small devices (phones, 600px and down) */
    .lookingOffering {
        width: 100%;
        text-align: -webkit-right;
    }
    .tltFiledValues.offeringInst.institute {
        padding-left: 24px;
    }  
    .tltFiledValues.lookingInst.institute {
        padding-left: 9px;
    }
    @media only screen and (max-width: 600px) {
        .mfgChangeStateButtons {
            flex-direction: column-reverse;
            row-gap: 20px;
            align-items: center;
        }

        .tltProfileBox .tltName {
            font-size: unset;
        }


        span.dx-button-text {
            display: unset;
        }

        .puFilter {
            flex-wrap: wrap;
        }

        .line {
            margin-bottom: unset;
        }

        .progress-bar {
            width: 100%;
        }

        .progress {
            display: flex;
            flex-direction: column;
            justify-self: center;
            width: 100%;
        }

        .missing-fields, .missing-fields div {
            text-align: center;
        }

        .page-content {
            margin: 10px 0px 10px 0px;
        }

        /* .content {
                text-align: center;
            }*/

        .img-bg {
            display: none;
        }

        .img-icon {
            padding: 0;
        }

        .icon-app {
            display: flex;
            flex-direction: column;
            justify-items: center;
            padding: 0;
            gap: 20px;
        }

        h3.head-forth {
            text-align: center;
        }

        div.icon-app > div {
            justify-items: center;
            text-align: center;
        }

        .lgi-btns {
            padding-top: 30px;
            padding-right: 0;
            padding-left: 0;
            flex-direction: column;
        }

            .lgi-btns .dx-button {
                width: auto !important;
            }

        span.grey-text {
            text-align: center;
            padding-top: 10px;
            padding-bottom: 10px;
        }
    }
    .tltDevider{
        border:none;
    }
    .tltProfileBox .tltDevider {
        grid-area: tltDivider;
        border-top: solid 1px silver;
    }

    @media only screen and (max-width: 300px) {
        .tltCardBox {
            padding: 10px;
        }

        .tltProfileBox {
            gap: 10px 0px;
        }

        .puAiFilter .puValue {
            flex-direction: column;
            row-gap: 20px;
        }

        .tltProfileBox .tltPhoto img.tltProfilePhoto {
            width: 50px;
            height: unset;
        }
    }

    .hideField, .hideField .tltFiledValues {
        visibility: hidden;
        height: 0px;
    }
</style>
